<template>
  <div class="flex flex-col w-full bg-white p-5 mt-6 mb-6 rounded shadow-md">
    <!-- Title and Header Section -->
    <div class="flex items-center mb-4">
      <h3 class="uppercase text-lg font-semibold text-primary tracking-wide mr-4">
        Calibration
      </h3>
      <hr class="flex-grow border-primary border-t-2 mr-4"/>
    </div>

    <!-- Calibration Data Table -->
    <div class="bg-gray-100 p-4 rounded-md">
      <div class="grid grid-cols-6 rounded-md text-center font-medium bg-gray-200 p-2 uppercase font-semibold"
           style="column-gap: 20px;">
        <div>Weight Applied <br> (Kg)</div>
        <div>Force Applied<br> (Kgf)</div>
        <div>Reading <br> (kgf)</div>
        <div>% Error <br> (max 3%)</div>
        <div>Error <br> Tolerance</div>
        <div>Weight Reading <br> (kg)</div>
      </div>

      <div v-for="(item, index) in form.calibration" :key="index"
           class="grid grid-cols-6 text-center mt-4" style="column-gap: 20px;">
        <input type="text" v-model="item.weight_applied"     class="input-style text-gray-500" readonly>
        <input type="text" v-model="item.kgf_force_applied"  class="input-style text-gray-500" readonly>
        <input type="text" v-model="item.reading"            class="input-style">
        <input type="text" v-model="item.percent_error"      class="input-style">
        <input type="text" v-model="item.error_tolerance"    class="input-style text-gray-500" readonly>
        <input type="text" v-model="item.weight_scales"      class="input-style">
      </div>
    </div>
  </div>
</template>

<script>
function defaultRows () {
  return [
    { weight_applied: 0,   kgf_force_applied: 0,   reading: 0, percent_error: 0, error_tolerance: '0',        weight_scales: 0 },
    { weight_applied: 10,  kgf_force_applied: 100, reading: 0, percent_error: 0, error_tolerance: '97 - 103', weight_scales: 0 },
    { weight_applied: 20,  kgf_force_applied: 200, reading: 0, percent_error: 0, error_tolerance: '194 - 206',weight_scales: 0 },
    { weight_applied: 30,  kgf_force_applied: 300, reading: 0, percent_error: 0, error_tolerance: '291 - 309',weight_scales: 0 },
    { weight_applied: 40,  kgf_force_applied: 400, reading: 0, percent_error: 0, error_tolerance: '388 - 412',weight_scales: 0 },
    { weight_applied: 60,  kgf_force_applied: 0,   reading: 0, percent_error: 0, error_tolerance: '0',        weight_scales: 0 },
    { weight_applied: 70,  kgf_force_applied: 0,   reading: 0, percent_error: 0, error_tolerance: '0',        weight_scales: 0 },
    { weight_applied: 80,  kgf_force_applied: 0,   reading: 0, percent_error: 0, error_tolerance: '0',        weight_scales: 0 },
    { weight_applied: 100, kgf_force_applied: 0,   reading: 0, percent_error: 0, error_tolerance: '0',        weight_scales: 0 },
    { weight_applied: 150, kgf_force_applied: 0,   reading: 0, percent_error: 0, error_tolerance: '0',        weight_scales: 0 },
    { weight_applied: 200, kgf_force_applied: 0,   reading: 0, percent_error: 0, error_tolerance: '0',        weight_scales: 0 }
  ];
}

function blankForm () {
  return {
    calibration: defaultRows()
  };
}

export default {
  name: 'RollerBrakeTesterMC',
  props: {
    calibration_details: { type: Object, default: function () { return {}; } }
  },
  emits: ['update:calibration_details'],
  data: function () {
    return {
      form: blankForm(),
      hasUserEdited: false
    };
  },
  mounted: function () {
    this.seedFrom(this.calibration_details);
  },
  watch: {
    calibration_details: {
      deep: true,
      handler: function (val) {
        if (!val) return;
        if (this.hasUserEdited) return;
        this.seedFrom(val);
      }
    },
    form: {
      deep: true,
      handler: function (v) {
        this.hasUserEdited = true;
        this.$emit('update:calibration_details', JSON.parse(JSON.stringify(v)));
      }
    }
  },
  methods: {
    // Saved rows are matched to the form rows by the weight applied, not by
    // position, so an older certificate keeps its readings under the right
    // weights. The kgf and tolerance are fixed reference values and always
    // come from the form's own list.
    seedFrom: function (src) {
      const safe = (src && typeof src === 'object') ? src : {};
      const saved = Array.isArray(safe.calibration) ? safe.calibration : [];
      const savedByWeight = new Map();
      saved.forEach(function (r) {
        if (r && r.weight_applied !== undefined && r.weight_applied !== null) {
          savedByWeight.set(Number(r.weight_applied), r);
        }
      });

      const pick = function (r, key, fallback) {
        return (r && r[key] !== undefined && r[key] !== null) ? r[key] : fallback;
      };

      this.form = {
        calibration: defaultRows().map(function (def) {
          const r = savedByWeight.get(Number(def.weight_applied));
          return {
            weight_applied:    def.weight_applied,
            kgf_force_applied: def.kgf_force_applied,
            reading:           pick(r, 'reading', def.reading),
            percent_error:     pick(r, 'percent_error', def.percent_error),
            error_tolerance:   def.error_tolerance,
            weight_scales:     pick(r, 'weight_scales', def.weight_scales)
          };
        })
      };

      this.hasUserEdited = false;
    },

    getCurrentData: function () {
      return JSON.parse(JSON.stringify(this.form));
    }
  }
};
</script>

<style scoped>
.input-style {
  padding: 0.5rem;
  background: white;
  border: 1px solid #eee;
  border-radius: 0.25rem;
  width: 100%;
  text-align: center;
}
</style>
